/* eslint-disable react/no-array-index-key */
import * as React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { Box, Chip } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

function RecentActivities({ data }) {
  return (
    <Timeline
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0
        }
      }}
    >
      {data &&
        data.map((item, index) => {
          return (
            <React.Fragment key={item.unique_id}>
              <TimelineItem>
                <TimelineSeparator>
                  <TimelineDot
                    sx={{
                      backgroundColor: item.color,
                      boxShadow: '0 0 0 0.1875rem rgba(115,103,240,.16)'
                    }}
                  />
                  {data.length !== index + 1 ? <TimelineConnector /> : ''}
                </TimelineSeparator>
                <TimelineContent sx={{ py: 0 }}>
                  <ListItem
                    component="div"
                    sx={{ p: 0, pr: '120px' }}
                    disableGutters
                    secondaryAction={
                      <Chip
                        size="small"
                        label={item.time}
                        color="primary"
                        icon={<AccessTimeIcon sx={{ fontSize: '14px !important' }} />}
                        variant="contained"
                        sx={{
                          borderRadius: '16px',
                          mb: 1,
                          '.MuiChip-label': {
                            fontSize: '14px',
                            fontWeight: '400 !important',
                            opacity: '1'
                          }
                        }}
                      />
                    }
                  >
                    <ListItemText
                      primary={
                        <Box
                          sx={{ fontWeight: 'normal !important' }}
                          dangerouslySetInnerHTML={{ __html: item.event }}
                        />
                      }
                      secondary={
                        <>
                          <Typography
                            sx={{ display: 'inline' }}
                            component="span"
                            variant="body2"
                            color="text.primary"
                          >
                            Record ID
                          </Typography>
                          {`: #${item.record_id}`}
                        </>
                      }
                    />
                  </ListItem>
                </TimelineContent>
              </TimelineItem>
              {/*
              <Divider variant="inset" component="li" /> */}
            </React.Fragment>
          );
        })}
    </Timeline>
  );
}

RecentActivities.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      event: PropTypes.string.isRequired,
      time: PropTypes.string.isRequired,
      record_id: PropTypes.string,
      color: PropTypes.string.isRequired,
      unique_id: PropTypes.string.isRequired
      // Add other properties expected in the object
    })
  ).isRequired
};

export default RecentActivities;
